// @flow
import React from 'react';
import type { Node } from 'react';

import styles from './Button.module.scss';

type Props = {
  className: string,
  autofocus: boolean,
  disabled: boolean,
  type: string,
  url: string,
  onClick: () => mixed,
  children: Node
};

const Button = ({
  className,
  autofocus,
  disabled,
  type,
  url,
  onClick,
  children
}: Props): Node => {
  const fullClassName = `${styles.button} ${className}`;

  if (url) {
    return (
      <a className={fullClassName} href={url}>
        {children}
      </a>
    );
  }

  return (
    <button
      className={fullClassName}
      autoFocus={autofocus}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

Button.displayName = 'Button';

Button.defaultProps = {
  className: '',
  autofocus: false,
  disabled: false,
  type: 'submit',
  url: '',
  onClick: () => undefined,
  children: ''
};

export default Button;
